import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-hub-status',
  templateUrl: './hub-status.component.html',
  styleUrls: ['./hub-status.component.scss'],
})
export class HubStatusComponent implements OnInit {
  @Input() status: string;
  constructor() {}

  statusClassName: string;
  statusLabel: string;

  ngOnInit(): void {
    this.assignStatusClass();
  }

  assignStatusClass() {
    if (this.status == '1') {
      this.statusClassName = 'status-started';
      this.statusLabel = 'Started';
    } else if (this.status == '3') {
      this.statusClassName = 'status-open';
      this.statusLabel = 'Active';
    } else if (this.status == '5') {
      this.statusClassName = 'status-closed';
      this.statusLabel = 'Closed';
    } else if (this.status == '0') {
      this.statusClassName = 'status-deleted';
      this.statusLabel = 'Deleted';
    }
  }
}
